import React from 'react'
import Grid from '@material-ui/core/Grid'
import Button from '@material-ui/core/Button'
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'

import Input from 'components/shared/Input'

interface IProps {
  handlePasswordUpdate: (password: string) => void
  error: string
}

interface IState {
  password: string
  passwordConfirm: string
}

class PasswordUpdateScreen extends React.Component<IProps, IState> {
  constructor(props: any) {
    super(props)
    this.state = {
      passwordConfirm: '',
      password: '',
    }
  }

  _handlePasswordChange = (evt: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({
      ...this.state,
      password: evt.currentTarget.value,
    })
  }

  _handlePasswordConfirmChange = (evt: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({
      ...this.state,
      passwordConfirm: evt.currentTarget.value,
    })
  }

  _handlePasswordUpdate = async event => {
    const { password } = this.state
    event.preventDefault()
    this.props.handlePasswordUpdate(password)
  }

  _isDataValid = () => {
    const { password, passwordConfirm } = this.state
    return password && passwordConfirm && password === passwordConfirm
  }

  render() {
    const { password, passwordConfirm } = this.state
    const { error } = this.props
    return (
      <form name="login" onSubmit={this._handlePasswordUpdate}>
        <Grid container direction="column" spacing={3} style={{ backgroundColor: '#fff' }}>
          <Box p={{ xs: 2, md: 4, lg: 6 }}>
            <Grid item>
              <Input label="New Password" type="password" value={password} onChange={this._handlePasswordChange} />
            </Grid>
            <Grid item>
              <Input
                label="Confirm Password"
                type="password"
                value={passwordConfirm}
                onChange={this._handlePasswordConfirmChange}
              />
            </Grid>
            <Grid item>
              <Box mt={{ xs: 2 }}>
                <Typography variant="h4" color="error">
                  Password must be 6 characters including 1 number.
                </Typography>
              </Box>
            </Grid>
            <Grid item>
              <Box mt={{ xs: 2, md: 5 }}>
                <Button fullWidth variant="contained" type="submit" disabled={!this._isDataValid()}>
                  <Typography variant="h4" color="primary">
                    Change Password
                  </Typography>
                </Button>
              </Box>
            </Grid>
            {error && (
              <Box mt={{ xs: 2 }}>
                <Typography variant="h4" color="error">
                  {error}
                </Typography>
              </Box>
            )}
          </Box>
        </Grid>
      </form>
    )
  }
}

export default PasswordUpdateScreen
